import { LifeBuoy, ShieldCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const COLUMNS = [
    {
        icon: ShieldCheck,
        index: "01",
        title: "Prevention",
        text: "Strength and balance programs reduce how often people fall. They work, and we encourage them.",
    },
    {
        icon: LifeBuoy,
        index: "02",
        title: "Preparedness",
        text: "Falls still happen. Fall Safe Ready teaches you how to react when you lose your balance, how to land in ways that protect your head, hips and wrists, and how to get back up.",
    },
];

export default function Prevention() {
    return (
        <section className="pb-10 sm:pb-14 lg:pb-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="Our approach" title="Prevention lowers the odds. Preparedness lowers the damage." />
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-6 max-w-3xl text-lg leading-relaxed text-ink-soft">
                        We wear seatbelts even though we plan not to crash. Fall Safe Ready works the same way:
                        it adds to the fall-prevention programs you already know.
                    </p>
                </Reveal>
                <div className="mt-8 grid sm:mt-12 gap-6 md:grid-cols-2">
                    {COLUMNS.map((c, i) => (
                        <Reveal key={c.title} delay={i * 0.1} className="h-full">
                            <div
                                className={`relative h-full rounded-3xl border p-8 lg:p-10 ${
                                    i === 1 ? "border-teal-600/30 bg-teal-50" : "border-clay bg-white"
                                }`}
                            >
                                <span className="absolute right-8 top-8 font-display text-2xl font-black text-brand-amber" aria-hidden="true">
                                    {c.index}
                                </span>
                                <span className="grid h-11 w-11 sm:h-14 sm:w-14 place-items-center rounded-2xl bg-teal-700 text-white" aria-hidden="true">
                                    <c.icon className="h-7 w-7" />
                                </span>
                                <h3 className="mt-6 font-display text-2xl font-extrabold text-ink">{c.title}</h3>
                                <p className="mt-3 text-lg leading-relaxed text-ink-soft">{c.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}